import { RefetchQueriesOptions, useApolloClient } from '@apollo/client';

const fieldNames = [
  'profile',
  'workspace',
  'workspaceVariables',
  'wizard',
  'organisation',
  'flatOrganisations',
  'user',
  'userOrganisation',
  'userWorkspace',
  'userAssociations',
  'assessments',
  'assessment',
  'incidents',
  'incident',
  'controls',
  'control',
  'scenario',
  'scenarioRmp',
  'scenarioControls',
  'events',
  'event',
  'usersEmails',
  'controlFrameworkDetails',
  'complianceFramework',
  'filtersFor',
] as const;

type KeyType = (typeof fieldNames)[number];

type RefetchQuery = (params?: {
  include?: KeyType[] | 'all';
  options?: RefetchQueriesOptions<any, any>;
}) => Promise<any>;

export const useCache = () => {
  const client = useApolloClient();

  const refetchQuery: RefetchQuery = async (params) => {
    const { include, options } = params || {};

    if (Array.isArray(include)) {
      include.forEach((fieldName) => {
        client.cache.evict({ fieldName });
      });
    }

    if (include === 'all') {
      fieldNames.forEach((fieldName) => {
        client.cache.evict({ fieldName });
      });
    }

    await client.cache.gc();

    await client.refetchQueries({
      include,
      ...options,
    });
  };

  // // Clear cache completely
  // const clearCache = async () => {
  //   await client.clearStore();
  // };

  return {
    refetchQuery,
  };
};
